/**
 * Default Ammonia Audit Template
 *
 * Mirrors the canonical flow defined in docs/mental-model-report-generation.md:
 * - Page 1 metadata (company, schedule, authorisation, CPI, contacts, attendees)
 * - Per-unit characteristics (components + safety design)
 * - Visit checks (unit findings, DPI, infrastructure, drills, registries, INAIL)
 * - Closure (findings, corrective actions, scorecard)
 */

import type { ReportTemplate } from "./schemas";
import {
  DEFAULT_TEMPLATE_GROUPS,
  DEFAULT_TEMPLATE_SECTIONS,
} from "./defaultTemplateData";

const cloneTemplateData = <T,>(value: T): T =>
  JSON.parse(JSON.stringify(value)) as T;

export function createDefaultTemplate(): ReportTemplate {
  const VERSION = "2026-01-06-v14";
  const now = new Date().toISOString();

  return {
    id: "tpl-ammonia-audit",
    version: VERSION,
    name: "Verbale Gas Tossici",
    groups: cloneTemplateData(DEFAULT_TEMPLATE_GROUPS),
    sections: cloneTemplateData(DEFAULT_TEMPLATE_SECTIONS),
    metadata: {
      targetType: "ammonia-audit",
      locale: "it-IT",
      createdAt: now,
      updatedAt: now,
    },
  };
}
